import React from 'react';
import { SETTINGS } from 'refactored/features/emergencies/constants';
import ticketService from 'refactored/features/emergencies/ticket-service';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import RegularText from 'refactored/features/emergencies/ui/texts/regular-text';
import styled from 'styled-components';

const CustomText = styled(RegularText)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ color }) => color};
`;

const CustomRegularText = styled(RegularText)`
  font-size: 12px;
  font-weight: 500;
`;

export const TicketColumn = ({ ticket }) => {
  const ticketColor = ticketService.bussiness.getTicketColor(ticket);

  return (
    <BodyColumn
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.TICKET}
      columnBorderLeftColor={ticketColor}
    >
      <CustomText color={ticketColor}>
        ID. {ticketService.utils.getFormatedId(ticket.id)}{' '}
      </CustomText>
      <CustomRegularText>
        {`REF. ${
          ticket.order_data.complementary_info.customer_internal_reference ||
          '-'
        }`}
      </CustomRegularText>
    </BodyColumn>
  );
};
